import MuiOutlinedInput from "./MuiOutlinedInput";
import MuiButton from "./MuiButton";
const override = {
  MuiButton,
  MuiOutlinedInput,
};
export default override
